<template>
  <div
    class="px-8 py-6 ma-0"
    :style="{
      width: '100%',
      overflowY: 'auto',
      height: '900px',
      maxHeight: '1400px',
    }"
  >
    <div class="pb-5">
      <h3>{{ constructionId ? "현장 수정" : "현장 추가" }}</h3>
    </div>

    <v-card class="back-white" :height="isEditPage ? '90%' : 900">
      <v-tabs color="#739EEC" v-if="isEditPage">
        <v-tab @click="tab = 0">현장 정보</v-tab>
        <v-tab @click="tab = 1">발주계획 수량</v-tab>
      </v-tabs>

      <div v-if="!isEditPage || (isEditPage && tab === 0)">
        <v-row align="center" class="pa-5 pt-10 pb-3">
          <div class="width-150 pl-5 ml-5">
            <span>시공상태</span>
            <span class="required-text">(필수*)</span>
          </div>
          <div>
            <v-select
              class="border-width"
              :items="state"
              v-model="constList.completion"
              solo
              flat
              dense
              :menu-props="{ offsetY: true }"
            />
          </div>
          <span class="margin-left-120 width-120">
            샵업체
          </span>
          <div>
            <input
              v-model="shopCompany"
              class="border-width-short input-title"
              disabled
            />
            <div class="input-text" v-if="shopCompany">
              {{ shopCompany }}
            </div>
          </div>
        </v-row>
        <v-row align="center" class="pa-5 pt-2 pb-3">
          <div class="width-150 pl-5 ml-5">
            <span>현장명 </span>
            <span class="required-text"> (필수*)</span>
          </div>
          <div>
            <input class="border-width" v-model="constList.constructionName" />
          </div>
          <span class="margin-left-120 width-120">
            샵 담당자
          </span>
          <div class="mr-5">
            <input
              class="border-width-short input-title"
              v-model="shopManager"
              disabled
            />
            <div class="input-text" v-if="shopManager">
              {{ shopManager }}
            </div>
          </div>
          <div class="ml-5">
            <SelectModal
              :statement="'샵업체'"
              @sendManager="sendShopManager"
              :constructionId1="constructionId"
            />
          </div>
        </v-row>
        <v-row align="center" class="pa-5 pt-2 pb-3 ">
          <span class="width-150 pl-5 ml-5">
            현장코드<span class="required-text">(필수*)</span>
          </span>
          <div>
            <input class="border-width" v-model="constList.constructionCode" />
          </div>
          <span class="margin-left-120 width-120">
            가공장
          </span>
          <div>
            <input
              class="border-width-short input-title"
              v-model="plant"
              disabled
            />
            <div class="input-text" v-if="plant">
              {{ plant }}
            </div>
          </div>
        </v-row>
        <v-row align="center" class="pa-5 pt-2 pb-3">
          <span class="width-150 pl-5 ml-5">
            현장주소
          </span>
          <div>
            <input
              class="border-width"
              v-model="constList.constructionAddress"
            />
          </div>
          <span class="width-120 margin-left-120">
            가공장 담당자
          </span>
          <div class="mr-5">
            <input
              class="border-width-short input-title"
              v-model="plantManager"
              disabled
            />
            <div class="input-text" v-if="plantManager">
              {{ plantManager }}
            </div>
          </div>

          <div class="ml-5">
            <SelectModal
              :statement="'가공업체'"
              @sendManager="sendPlantManager"
              :constructionId1="constructionId"
            />
          </div>
        </v-row>
        <v-row align="center" class="pa-5 pt-2 pb-3">
          <span class="width-150 pl-5 ml-5">
            현장담당자
          </span>
          <div>
            <input
              class="border-width input-title"
              v-model="constructionManager"
              disabled
            />
            <div class="input-text" v-if="constructionManager">
              {{ constructionManager }}
            </div>
          </div>
          <div class="mr-3 ml-3">
            <SelectModal
              :statement="'관리자'"
              @sendManager="sendManager"
              :constructionId1="constructionId"
              :disabled="roleType"
            />
          </div>
        </v-row>
        <v-row align="center" class="pa-5 pt-2 pb-3">
          <div class="d-flex pb-3">
            <div class="d-flex align-center width-150 pl-5 ml-5">
              착공일
            </div>
            <div>
              <v-menu
                offset-y
                :close-on-content-click="false"
                v-model="constructionDateMenu"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="align-center" style="width:356px">
                    <v-text-field
                      v-model="constructionDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      class="ma-0 pa-0"
                      dense
                      outlined
                      height="42"
                    ></v-text-field>
                  </div>
                </template>

                <DefaultDatePicker
                  @update:date="
                    (data) => updateReceivedDate(data, 'constructionDate')
                  "
                  @close:date="constructionDateMenu = false"
                  :noTitle="true"
                  width="340"
                />
              </v-menu>
            </div>
          </div>
          <div class="d-flex pb-3">
            <div class="d-flex align-center width-120 margin-left-120">
              준공일
            </div>
            <div>
              <v-menu
                offset-y
                :close-on-content-click="false"
                v-model="completionDateMenu"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    class="width179-height35 align-center"
                    style="width:356px"
                  >
                    <v-text-field
                      v-model="completionDate"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      hide-details
                      class="ma-0 pa-0 "
                      dense
                      outlined
                      height="42"
                    ></v-text-field>
                  </div>
                </template>

                <DefaultDatePicker
                  @update:date="
                    (data) => updateReceivedDate(data, 'completionDate')
                  "
                  @close:date="completionDateMenu = false"
                  :noTitle="true"
                  width="340"
                />
              </v-menu>
            </div></div
        ></v-row>
      </div>

      <!-- <OrderPlanTable
        v-else
        :rebarList="rebarList"
        :rebarHeader="rebarHeader"
        class="pt-10"
      /> -->

      <div
        v-if="!isEditPage || (isEditPage && tab === 1)"
        :class="[
          isEditPage ? 'pt-10' : '',
          'd-flex flex-column mr-3 ml-3 pl-3',
        ]"
      >
        <h3 class="px-5 pt-1 mb-5">
          발주계획 수량
        </h3>
      </div>
      <v-row
        justify="center"
        v-if="!isEditPage || (isEditPage && tab === 1)"
        :class="[
          !isEditPage || (isEditPage && tab === 1) ? 'mb-3' : '',
          'pa-3 mr-3 ml-3',
        ]"
      >
        <v-simple-table class="border-dddddd">
          <thead>
            <th
              class="back-8ca9dd  color-white "
              style="width:80px !important;"
            ></th>
            <th
              v-for="(th, i) in rebarList[0]"
              :key="i"
              class="back-8ca9dd color-white border-left-white"
            >
              {{ th.rebarName.replace(th.rebarType, "") }}
            </th>
            <th class="back-8ca9dd color-white border-left-white">합계</th>
          </thead>

          <tbody>
            <tr v-for="i in rebarHeader.length" :key="i">
              <td>{{ rebarList[i - 1][0].rebarType }}</td>
              <td
                v-for="(td, j) in rebarList[i - 1]"
                :key="j"
                class="pl-2 pr-2 border-aaaaaa"
              >
                <input
                  type="number"
                  solo
                  outlined
                  v-model="tempList[(i - 1) * rebarList[i - 1].length + j]"
                  class="border-aaaaaa width-100 text-center"
                />
              </td>
              <td class="border-aaaaaa width-100 text-center">
                {{ sumTotal(tempList, i - 1) }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-row>
      <v-row
        justify="center"
        align="center"
        :class="[isEditPage ? 'mt-10' : '', '']"
      >
        <v-btn
          width="150"
          height="40"
          color="#739EEC"
          class="color-white mr-3"
          @click="uporCreated"
          :disabled="btnStatus"
        >
          등록완료
        </v-btn>
        <v-btn
          width="150"
          height="40"
          color="#EEEEEE"
          @click="$router.push({ name: 'Construction' })"
        >
          뒤로가기
        </v-btn>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import ConstApi from "@/api/ConstructionService";
import RebarService from "@/api/RebarService";
import SelectModal from "./modal/SelectModal.vue";
import RebarApi from "@/api/RebarService";
// import OrderPlanTable from "@/components/editArea/OrderPlanTable.vue";
import DefaultDatePicker from "@/components/DefaultDatePicker.vue";

export default {
  components: {
    SelectModal,
    // OrderPlanTable,
    DefaultDatePicker,
  },
  props: ["constructionId"],

  async created() {
    if (this.constructionId) {
      this.startMethod();
    } else {
      for (let i = 0; i < 54; i++) {
        this.tempList[i] = 0;
      }
    }
    this.init();
  },

  data: () => ({
    state: ["시공대기", "시공중", "시공완료"],
    tempHeader: ["10", "13", "16", "19", "22", "25", "29", "32", "35", "합계"],
    tempSubHeader: ["HD", "SHD", "UHD", "S HD", "S SHD", "S UHD"],
    tempList: [],
    constList: {
      completion: "",
      constructionAddress: "",
      constructionId: "",
      constructionManagerId: [],
      constructionName: "",
      invoiceManagerId: [],
      orderManagerId: [],
      managerPhone: "",
      rebarQtys: [],
      constructionCode: "",
      rebarListData: [],
    },
    selectState: "",
    shopManager: "",
    shopCompany: "",
    construction: "",
    constructionAddress: "",
    plant: "",
    constructionManager: "",
    managerPhone: "",
    plantManager: "",
    managerList: [
      {
        shop: [],
        plant: [],
        manager: [],
      },
    ],
    rebarList: [],
    rebarHeader: [],
    btnStatus: false,
    tab: 0,
    constructionDate: null,
    completionDate: null,
    constructionDateMenu: false,
    completionDateMenu: false,
  }),
  computed: {
    materialList() {
      return this.$store.state.Const.rebarList;
    },

    header() {
      let headerList = [];
      for (let i = 0; i < this.materialList.length; i++) {
        headerList.push(this.materialList[i].rebar_name + "mm");
      }
      return headerList;
    },

    storeConstructionId() {
      return this.$store.state.Const.constructionId.constructionId ?? "";
    },
    roleType() {
      return this.$store.getters.getUserList.roleType;
    },
    isEditPage() {
      return this.constructionId ? true : false;
    },
  },
  methods: {
    async init() {
      let res = await RebarService.standardRebarList();
      let tempList = res.data.list.map((a) => a.rebarType);
      let ts = [...new Set(tempList)];
      this.rebarHeader = ts;
      this.rebarList = ts.map((a) =>
        res.data.list.filter((b) => b.rebarType == a)
      );
    },

    async startMethod() {
      let data = {
        constructionId: this.constructionId,
      };
      this.constList.constructionId = this.constructionId;
      let returnData = await ConstApi.constructionInformation(data);
      let result = returnData.data.constInformation;
      let constructionManager = this.findManager(result, "현장관리자");
      let invoiceManager = this.findManager(result, "입고담당자");
      let orderManager = this.findManager(result, "발주담당자");
      if (orderManager) {
        this.shopManager = [
          ...new Set(orderManager.map((a) => a.constructionAdmin)),
        ].join(", ");
        this.shopCompany = orderManager.map((a) => a.companyName).join(", ");
        this.constList.orderManagerId = orderManager.map(
          (a) => a.constructionAdminId
        );
      } else {
        this.constList.orderManagerId = [];
        this.shopCompany = null;
        this.shopManager = null;
      }

      if (constructionManager) {
        this.constructionManager = constructionManager
          .map((a) => a.constructionAdmin)
          .join(", ");
        this.constList.constructionManagerId = constructionManager.map(
          (a) => a.constructionAdminId
        );
      } else {
        this.constList.constructionManagerId = [];
        this.constructionManager = null;
      }

      if (invoiceManager) {
        this.plantManager = invoiceManager
          .map((a) => a.constructionAdmin)
          .join(", ");
        this.plant = [
          ...new Set(invoiceManager.map((a) => a.companyName)),
        ].join(", ");
        this.constList.invoiceManagerId = invoiceManager.map(
          (a) => a.constructionAdminId
        );
      } else {
        this.constList.invoiceManagerId = [];
        this.plantManager = null;
        this.plant = null;
      }
      this.constList.completion = result[0].completion;
      this.constList.constructionId = result[0].constructionId;
      this.constList.constructionName = result[0].constructionName;
      this.constList.constructionAddress = result[0].constructionAddress;
      this.constList.constructionCode = result[0].constructionCode;
      for (let i of result[0].rebarQty) {
        this.tempList.push(i);
      }
      this.constList.rebarQtys = result[0].rebarQty;
      this.constructionDate = result[0]?.startDate;
      this.completionDate = result[0]?.endDate;
    },
    reset() {
      this.selectState = "";
      this.shopManager = "";
      this.shopCompany = "";
      this.construction = "";
      this.plantManager = "";
    },
    /** companyType 업체기준으로 담당자 찾기 */
    findManager(type, payload) {
      const companyTypes = {
        발주담당자: "샵업체",
        입고담당자: "가공업체",
        현장관리자: "관리자",
      };
      let list = [];
      for (let i = 0; i < type.length; i++) {
        if (
          // type[i].roleType == payload
          type[i].companyType == companyTypes[payload]
        ) {
          list.push(type[i]);
        }
      }
      return list;
    },

    sumTotal(payload1, payload2) {
      let sum = 0;
      let headerLength = this.rebarList[0].length;
      for (let i = 0; i < headerLength; i++) {
        if (payload1[i + headerLength * payload2])
          sum += Number(payload1[i + headerLength * payload2]);
      }
      return sum;
    },

    async uporCreated() {
      this.$bus.$emit("loadingStart");
      let text = "";
      this.btnStatus = true;
      if (this.constList.constructionName.length < 4)
        text = "현장명 4글자 이상 입력해주세요.";
      else if (this.constList.constructionCode.length < 4)
        text = "현장코드를 4글자 이상 입력해주세요.";
      else if (this.tempList.reduce((a, b) => (a += b)) <= 0)
        text = "실행수량 총 합이 0보다 커야합니다.";
      else {
        let headerLength = this.tempHeader.length - 1;
        this.constList.rebarListData = [];
        for (let j = 0; j < this.tempList.length; j++) {
          let content = this.rebarList[
            Math.floor(j / this.rebarList[j % this.rebarList.length].length)
          ][j % this.rebarList[j % this.rebarList.length].length].rebarName;
          this.constList.rebarListData.push({
            rebarName: content,
            rebarValue: this.tempList[j] ? Number(this.tempList[j]) : 0,
          });
        }
        let data = this.constList;
        let result = "";

        this.constList.startDate = this.constructionDate;
        this.constList.endDate = this.completionDate;

        if (this.constructionId) {
          const isEditTable = this.constList.rebarQtys.some(
            (val, idx) => val !== Number(this.tempList[idx])
          );
          const isEditAreaInfo = this.isEditPage && this.tab === 0;
          const isNotEditTable = !isEditTable || isEditAreaInfo;

          const { rebarListData, ...rest } = this.constList;
          const payload = {
            ...rest,
            rebarListData: isNotEditTable ? null : rebarListData,
          };

          result = await ConstApi.constructionUpdate(payload);
          text = "현장 수정을 완료했습니다.";
        } else {
          result = await ConstApi.constructionCreate(data);
          text = "현장 등록을 완료했습니다.";
        }
        if (result.data.success === "ok") {
          this.$router.push({ name: "Construction" });
          let returnData = await RebarApi.rebarList({
            constructionId: this.storeConstructionId,
          });
          this.$store.commit("rebarListChange", returnData.data.RebarList);
        } else {
          text = `${
            result.data.reason ? result.data.reason : result.data.message
          } \n확인 후 다시 시도해주세요.`;
          this.$bus.$emit("loadingEnd");
        }
      }
      this.$bus.$emit("dialog", text);
      this.btnStatus = false;
      this.$bus.$emit("loadingEnd");
    },

    sendShopManager(value) {
      this.constList.orderManagerId = value.manager.map((a) => a.userId);
      this.shopManager = value.manager.map((a) => a.userName).join(", ");
      this.shopCompany = [
        ...new Set(value.manager.map((a) => a.companyName)),
      ].join(", ");
    },

    sendPlantManager(value) {
      this.constList.invoiceManagerId = value.manager.map((a) => a.userId);
      this.plantManager = value.manager.map((a) => a.userName).join(", ");
      this.plant = [...new Set(value.manager.map((a) => a.companyName))].join(
        ", "
      );
    },

    sendManager(value) {
      this.constList.constructionManagerId = value.manager.map((a) => a.userId);
      this.constructionManager = value.manager
        .map((a) => a.userName)
        .join(", ");
    },
    sum(list) {
      if (!list) return 0;
      let sum = 0;
      for (let i = 0; i < list.length; i++) {
        sum += Number(list[i] ? list[i] : 0);
      }
      return this.mathRound(sum);
    },
    updateReceivedDate(date, type) {
      this[type] = date;
      this[`${type}Menu`] = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-tab {
  font-weight: 700;
  letter-spacing: unset;
}
::v-deep .v-text-field .v-input__slot {
  border-radius: unset;
}
.border-dddddd {
  border: 1px solid #dddddd;
}
.input-text {
  padding: 15px 20px;
  background-color: #444444;
  border-radius: 5px;
  color: #ffffff;
  display: none;
  position: absolute;
  z-index: 15;
}
.input-title:hover + .input-text {
  display: block;
}
.v-text-field.v-text-field--solo .v-input__control {
  min-height: 25px !important;
  margin: 0px;
}
.width-100 {
  width: 100px;
}
.width-150 {
  width: 150px;
}
.padding-20 {
  padding-bottom: 20px;
}

h3 {
  color: black;
}

.border-radius {
  border-radius: 10px;
}

.border-width-short {
  width: 356px;
  height: 42px;
  border: thin solid #aaaaaa;
}
.color-556C96 {
  color: #556c96 !important;
}

.border-width {
  width: 356px;
  height: 42px;
  border: thin solid #aaaaaa;
}
.margin-left-120 {
  margin-left: 200px;
}
.width-120 {
  width: 120px;
}
.ml-22 {
  margin-left: 22px;
}
</style>
